import {
  AgentTaskEventSchema,
  AgentTaskExecutionStatus,
} from "@redotech/redo-model/agent-task-events";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const executeTaskOutput_ = z.object({
  status: createEnum(AgentTaskExecutionStatus, {
    enumName: "agent_task_execution_status",
  }),
  feedback: z.string().optional(),
  event: AgentTaskEventSchema,
});
export const ExecuteTaskOutput: z.ZodType<ExecuteTaskOutput> =
  executeTaskOutput_;
export interface ExecuteTaskOutput extends z.infer<typeof executeTaskOutput_> {}

export const executeTask = {
  name: "executeTask" as const,
  input: z.object({
    taskId: z.string(),
    input: z.string().optional(),
    autoCompleteOnExecute: z.boolean().optional(),
  }),
  output: executeTaskOutput_,
};
